export default function mergeRemoveField(way,field){
    
    var record = this.dataGet(way+"/newRecord");
    record = record.delete(field);
    this.dataSet(way+"/newRecord",record);
}